var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var GhostActionsArea = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 90px;\n  right: 15px;\n  text-align: center;\n  background-color: ", ";\n  border-radius: 3px;\n  padding: 15px;\n  opacity: 0.4;\n  transition: opacity 0.2s;\n  box-shadow: ", ";\n  :hover {\n    opacity: 1;\n  }\n  button {\n    box-shadow: ", ";\n  }\n"], ["\n  position: fixed;\n  top: 90px;\n  right: 15px;\n  text-align: center;\n  background-color: ", ";\n  border-radius: 3px;\n  padding: 15px;\n  opacity: 0.4;\n  transition: opacity 0.2s;\n  box-shadow: ", ";\n  :hover {\n    opacity: 1;\n  }\n  button {\n    box-shadow: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.mid;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.high;
});
var templateObject_1;
